/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import { useState, useEffect } from 'react';

// Restituisce il tempo trascorso (in secondi) da un timestamp di inizio, aggiornato ogni secondo
export function useElapsed(inizio) {
  const [elapsed, setElapsed] = useState(0);
  useEffect(() => {
    if (!inizio) { setElapsed(0); return; }
    const start = new Date(inizio).getTime();
    const tick = () => setElapsed(Math.max(0, Math.floor((Date.now() - start) / 1000)));
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, [inizio]);
  return elapsed;
}

// Formatta secondi in "HH:MM:SS"
export function fmtElapsed(sec) {
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = sec % 60;
  return [h, m, s].map((x) => String(x).padStart(2, '0')).join(':');
}

// Ore decimali da secondi (per i calcoli)
export function oreDecimali(sec) {
  return Math.round((sec / 3600) * 100) / 100;
}
